import script from "./HandlebarModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandlebarModule.vue?vue&type=script&setup=true&lang=ts"

import "./HandlebarModule.vue?vue&type=style&index=0&id=b8981bbc&lang=scss"

const __exports__ = script;

export default __exports__